"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _electricPlug = _interopRequireDefault(require("../../../shared/icons/electric-plug.svg"));

var _snowflake = _interopRequireDefault(require("../../../shared/icons/snowflake.svg"));

var _sun = _interopRequireDefault(require("../../../shared/icons/sun.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var seasons = {
  Summer: {
    dates: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "(", /*#__PURE__*/_react["default"].createElement("abbr", {
      title: "June"
    }, "Jun"), "\xA01 to\xA0", /*#__PURE__*/_react["default"].createElement("abbr", {
      title: "September"
    }, "Sep"), "\xA030)"),
    icon: _sun["default"],
    key: 'summer',
    figureInitialCost: false
  },
  Winter: {
    dates: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "(", /*#__PURE__*/_react["default"].createElement("abbr", {
      title: "November"
    }, "Nov"), "\xA01 to\xA0", /*#__PURE__*/_react["default"].createElement("abbr", {
      title: "March"
    }, "Mar"), "\xA031)"),
    icon: _snowflake["default"],
    key: 'winter',
    figureInitialCost: true
  }
};
var dayHour = 24;
var meridiemHour = 12;
var percent = 100;
var iconMinimumY = 7;
var scaleY = 0.25;

var EnergyCostGraph = function EnergyCostGraph(_ref) {
  var _ref$sliceData$primar = _ref.sliceData.primary,
      economyCost = _ref$sliceData$primar.economy_cost,
      figure = _ref$sliceData$primar.figure,
      peakCost = _ref$sliceData$primar.peak_cost,
      peakHoursStart = _ref$sliceData$primar.peak_hours_start,
      peakHoursStop = _ref$sliceData$primar.peak_hours_stop,
      season = _ref$sliceData$primar.season,
      showFigureText = _ref$sliceData$primar.show_figure_text,
      yMax = _ref$sliceData$primar.y_max;

  var toMeridiemString = function toMeridiemString(hour) {
    return "".concat(hour % meridiemHour || meridiemHour, " ").concat(hour >= meridiemHour ? 'pm' : 'am');
  };

  var toPercentString = function toPercentString(value) {
    return "".concat(value * percent, "%");
  };

  var toClassNames = function toClassNames() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.map(function (elMod) {
      return "energy-cost-graph--".concat(elMod);
    }).join(' ');
  };

  var conditionalUuid = function conditionalUuid(condition) {
    return condition ? (0, _v["default"])() : null;
  };

  var economyCostFriendly = "".concat(economyCost, "\xA2");
  var peakCostFriendly = "".concat(peakCost, "\xA2");
  var peakHourStartFriendly = toMeridiemString(peakHoursStart);
  var peakHourStopFriendly = toMeridiemString(peakHoursStop);
  var economyCostY = economyCost * scaleY;
  var peakCostY = peakCost * scaleY;
  var rangeY = Math.max(economyCost, peakCost, yMax) * scaleY;
  var PeakIcon = seasons[season].icon;
  var showEconomyIcon = economyCost >= iconMinimumY;
  var showPeakIcon = peakCost >= iconMinimumY;
  var figureElId = conditionalUuid(showFigureText);
  var columnWidths = [peakHoursStart / dayHour, (peakHoursStop - peakHoursStart) / dayHour, (dayHour - peakHoursStop) / dayHour];
  var columns = [{
    key: 'graph-label-range',
    className: toClassNames('col', 'col__range'),
    style: {
      height: "".concat(rangeY, "rem")
    }
  }, {
    key: 'graph-label-economy-start',
    className: toClassNames('col', 'col__economy', 'col__first'),
    role: 'img',
    'aria-label': "".concat(season, " economy hours, ranging from 12 am to ").concat(peakHourStartFriendly, ", costs ").concat(economyCost, " cents per kilowatt hour."),
    style: {
      width: toPercentString(peakHoursStart / dayHour),
      height: "".concat(economyCostY, "rem")
    },
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: toClassNames('col-text')
    }, economyCostFriendly), showEconomyIcon && /*#__PURE__*/_react["default"].createElement(_electricPlug["default"], {
      className: toClassNames('col-icon')
    }))
  }, {
    key: 'graph-label-peak',
    className: toClassNames('col', 'col__peak', "col__peak-".concat(seasons[season].key)),
    role: 'img',
    'aria-label': "".concat(season, " economy hours, ranging from ").concat(peakHourStartFriendly, " to ").concat(peakHourStopFriendly, ", costs ").concat(peakCost, " cents per kilowatt hour."),
    style: {
      width: "calc(".concat(toPercentString((peakHoursStop - peakHoursStart) / dayHour), " - .5rem)"),
      height: "".concat(peakCostY, "rem")
    },
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: toClassNames('col-text')
    }, peakCostFriendly), showPeakIcon && /*#__PURE__*/_react["default"].createElement(PeakIcon, {
      className: toClassNames('col-icon')
    }))
  }, {
    key: 'graph-label-economy-end',
    className: toClassNames('col', 'col__economy', 'col__last'),
    role: 'img',
    'aria-label': "".concat(season, " economy hours, ranging from ").concat(peakHourStopFriendly, " to 12 am, costs ").concat(economyCost, " cents per kilowatt hour."),
    style: {
      width: toPercentString((dayHour - peakHoursStop) / dayHour),
      height: "".concat(economyCostY, "rem")
    },
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: toClassNames('col-text')
    }, economyCostFriendly), showEconomyIcon && /*#__PURE__*/_react["default"].createElement(_electricPlug["default"], {
      className: toClassNames('col-icon')
    }))
  }];
  var intercolumns = [{
    key: 'graph-label-economy-start',
    className: toClassNames('intercol-label', 'intercol-label__first'),
    style: {
      width: toPercentString(columnWidths[0])
    },
    children: '12 am'
  }, {
    key: 'graph-label-peak-start',
    className: toClassNames('intercol-label'),
    style: {
      width: toPercentString(columnWidths[1] / 2)
    },
    children: /*#__PURE__*/_react["default"].createElement("div", null, peakHourStartFriendly)
  }, {
    key: 'graph-label-peak-end',
    className: toClassNames('intercol-label', 'intercol-label__right'),
    style: {
      width: toPercentString(columnWidths[1] / 2)
    },
    children: /*#__PURE__*/_react["default"].createElement("div", null, peakHourStopFriendly)
  }, {
    key: 'graph-label-economy-end',
    className: toClassNames('intercol-label', 'intercol-label__last'),
    style: {
      width: toPercentString(columnWidths[2])
    },
    children: '12 am'
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container energy-cost-graph-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__section-body-wrapper energy-cost-graph"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: toClassNames('months-header')
  }, "".concat(season, " months")), /*#__PURE__*/_react["default"].createElement("h4", {
    className: toClassNames('dates-header')
  }, seasons[season].dates), /*#__PURE__*/_react["default"].createElement("div", {
    className: toClassNames('graph'),
    "aria-labelledby": figureElId
  }, columns.map(function (column) {
    return /*#__PURE__*/_react["default"].createElement("div", column);
  }), intercolumns.map(function (label) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      "aria-hidden": "true"
    }, label));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: toClassNames('hours-details')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_electricPlug["default"], {
    className: toClassNames('hours-icon')
  }), /*#__PURE__*/_react["default"].createElement("strong", null, "".concat(season, " economy hours: ")), "12 am - ", peakHourStartFriendly, " & ", peakHourStopFriendly, " - 12 am"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(PeakIcon, {
    className: toClassNames('hours-icon', "hours-icon__".concat(seasons[season].key))
  }), /*#__PURE__*/_react["default"].createElement("strong", null, "".concat(season, " peak hours: ")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "energy-cost-graph__time"
  }, peakHourStartFriendly), " - ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "energy-cost-graph__time"
  }, peakHourStopFriendly))), figureElId && /*#__PURE__*/_react["default"].createElement("figure", {
    id: figureElId,
    className: toClassNames('figure')
  }, figure > 0 && /*#__PURE__*/_react["default"].createElement("strong", null, "Figure ".concat(figure, ". ")), "Energy costs", seasons[season].figureInitialCost ? " ".concat(peakCostFriendly, " per kWh ") : ' the most ', "during ", seasons[season].key, " month peak hours (", /*#__PURE__*/_react["default"].createElement("span", {
    className: "energy-cost-graph__time"
  }, peakHourStartFriendly), " - ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "energy-cost-graph__time"
  }, peakHourStopFriendly), ")", !seasons[season].figureInitialCost && " where the price for electricity is ".concat(peakCostFriendly, " per kWh"), ". To save money during weekdays, shift your energy use to economy pricing hours (", /*#__PURE__*/_react["default"].createElement("span", {
    className: "energy-cost-graph__time"
  }, peakHourStopFriendly), " - ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "energy-cost-graph__time"
  }, peakHourStartFriendly), ") when energy costs only ", economyCostFriendly, " per kWh.")));
};

EnergyCostGraph.propTypes = {
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      /* eslint-disable camelcase */
      economy_cost: _propTypes["default"].number.isRequired,
      figure: _propTypes["default"].number,
      peak_cost: _propTypes["default"].number.isRequired,
      peak_hours_start: _propTypes["default"].number.isRequired,
      peak_hours_stop: _propTypes["default"].number.isRequired,
      season: _propTypes["default"].oneOf(['Summer', 'Winter']).isRequired,
      show_figure_text: _propTypes["default"].bool.isRequired,
      y_max: _propTypes["default"].number
      /* eslint-enable camelcase */

    })
  }).isRequired
};
var _default = EnergyCostGraph;
exports["default"] = _default;